<template>
  <div class="verify">
    <guest-header />

    <div class="landing">
      <div class="container">
        <div class="row">
          <div class="col-md-6 offset-md-3">
            <div
              v-if="error.length == 0"
              class="loading"
            >
              <img src="/loading.gif">
            </div>
            <div
              v-if="error.length > 0"
              class="alert alert-danger-verify"
            >
              {{ error }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <guest-footer />
  </div>
</template>

<script>
    import GuestHeader from "@/components/Guest/Header.vue";
    import GuestFooter from "@/components/Guest/Footer.vue";

    export default {
        components: {
            GuestHeader, GuestFooter
        },

        data() {
            return {
                error: ''
            }
        },

        mounted() {
            if (this.$store.getters.getAuthUser.verified_email) {
                this.$router.push({name: 'login', query: {a: 1}});
            } else {
                this.verify();
            }
        },

        methods: {
            verify() {
                let data = {
                    code: this.$route.params.code
                };

                this.$axios.post('/api/v1/email/activate', data).then(() => {
                    this.$router.push({name: 'login', query: {a: 1}});
                }).catch(error => {
                    this.error = error.response.data.error;
                });
            }
        }
    }
</script>

<style lang="scss">
    .verify {
        .loading {
            width: 40%;
            margin: auto;
            margin-top: 20px;

            img {
                width: 100%;
            }
        }

        .alert {
            margin-top: 40px;
        }
    }
</style>
